import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import PurchaseScheduleForm from '../../components/Purchase/purchaseScheduleForm';
import { fetchVendors, fetchVendorDetail, resetCurrentVendor } from '../../actions/vendors_actions';
import { fetchProducts } from '../../actions/products_actions';
import { fetchPaymentTerms } from '../../actions/paymentTerms_actions';
import { selectPurchaseTemplate, resetCurrentPurchaseTemplate, convertTemplateToSchedule } from '../../actions/purchaseTemplates_actions';
import { fetchWarehouses } from '../../actions/warehouses_actions';
import { fetchPurchaseScheduleDetail, createPurchaseSchedule, editPurchaseSchedule } from '../../actions/purchaseSchedules_actions';


let purchaseScheduleForm = reduxForm({
    form: 'purchaseScheduleForm',
})(PurchaseScheduleForm);

const selector = formValueSelector('purchaseScheduleForm')

function mapStateToProps(state) {
    const productsValue = selector(state, 'PurchaseTemplate.Purchase_Template_Line');
    const vendorsValue = selector(state, 'PurchaseTemplate.Vendor_id');
    const vendorContactValue = selector(state, 'PurchaseTemplate.VendorContact');
    const priceTypeValue = selector(state, 'PurchaseTemplate.ConvertItemPrice');
    const miscCostValue = selector(state, 'PurchaseTemplate.MiscCost');
    const repeatFreqValue = selector(state, 'RepeatFrequency');
    return {
        productsValue: productsValue,
        vendorsValue: vendorsValue,
        vendorContactValue: vendorContactValue,
        priceTypeValue: priceTypeValue,
        miscCostValue: miscCostValue,
        repeatFreqValue: repeatFreqValue,

        currentPurchaseTemplate: state.purchaseTemplates.currentPurchaseTemplate,

        currentPurchaseScheduleDetail: state.purchaseSchedules.currentPurchaseScheduleDetail,
        currentPurchaseSchedule: state.purchaseSchedules.currentPurchaseSchedule,
        detailIsLoading: state.purchaseSchedules.detailIsLoading,
        detailError: state.purchaseSchedules.detailError,
        initialValues: state.purchaseSchedules.currentPurchaseScheduleDetail,

        isEditing: state.purchaseSchedules.purchaseScheduleIsEditing,
        editError: state.purchaseSchedules.purchaseScheduleEditError,
        isCreating: state.purchaseSchedules.purchaseScheduleIsCreating,
        createError: state.purchaseSchedules.purchaseScheduleCreateError,

        products: state.products.all,
        productIsLoading: state.products.isLoading,
        productError: state.products.error,
        vendors: state.vendors.all,
        vendorIsLoading: state.vendors.isLoading,
        vendorError: state.vendors.error,
        currentVendorDetail: state.vendors.currentVendorDetail,
        vendorDetailIsLoading: state.vendors.detailIsLoading,
        vendorDetailError: state.vendors.detailError,
        paymentTerms: state.paymentTerms.all,
        paymentTermsIsLoading: state.paymentTerms.isLoading,
        paymentTermsError: state.paymentTerms.error,
        warehouses: state.warehouses.all,
        warehouseIsLoading: state.warehouses.isLoading,
        warehouseError: state.warehouses.error,
        userPermissions: state.auth.userPermissions
    }
}

export default connect(mapStateToProps, {
    fetchVendors, fetchProducts, fetchPaymentTerms, fetchVendorDetail,
    resetCurrentVendor, fetchPurchaseScheduleDetail, createPurchaseSchedule, editPurchaseSchedule,
    selectPurchaseTemplate, resetCurrentPurchaseTemplate, convertTemplateToSchedule, fetchWarehouses
})(purchaseScheduleForm)



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchaseScheduleForm.jsx